/* eslint-disable no-param-reassign */
/* eslint-disable no-case-declarations */
export default {
    SET_BANKOPERATION_SELECTED(state, payload) {
        switch (payload.action) {
            case 'add':
                state.bankOperationsSelected.push(payload.item);
                break;
            case 'remove':
                const indexItem = state.bankOperationsSelected.indexOf(payload.item);
                state.bankOperationsSelected.splice(indexItem, 1);
                break;
            default:
                break;
        }
    },
    REMOVE_BANKOPERATION(state, item) {
        const index = state.bankOperationsSelected.indexOf(item);
        state.bankOperationsSelected.splice(index, 1);
    },
    REMOVE_RDOPERATION(state, item) {
        const index = state.RDOperationsSelected.indexOf(item);
        state.RDOperationsSelected.splice(index, 1);
    },
    REMOVE_BANKOPERATIONS_SELECTED(state) {
        state.bankOperationsSelected = [];
    },
    SET_RDOPERATION_SELECTED(state, payload) {
        switch (payload.action) {
            case 'add':
                state.RDOperationsSelected.push(payload.item);
                break;
            case 'remove':
                const indexItem = state.RDOperationsSelected.indexOf(payload.item);
                state.RDOperationsSelected.splice(indexItem, 1);
                break;
            default:
                break;
        }
    },
    REMOVE_RDOPERATIONS_SELECTED(state) {
        state.RDOperationsSelected = [];
    },
    SET_GROUPED_SELECTED(state, value) {
        state.groupedSelected = value;
    },
    SET_UUID_GROUPED_SELECTED(state, value) {
        state.uuidGroupedSelected = value;
    },
    SET_DISABLE_GROUPS(state, value) {
        state.disableGroups = value;
    },
    SET_COMMENT(state, value) {
        state.comment = value;
    },
    SET_DISABLEALL(state, value) {
        state.disableAll = value;
    }
};
